import styled from "styled-components";
import {Select} from "antd";

export const SelectField = styled(Select)`
    width: 100%;
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            width: 100%;
            font-size: 12px;
        }
    }
`;
